<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">
    Localização (Origem/Destino)
  </div>
  @if (checkPermission('criar')) {
    <div class="mr-8">
      <button mat-raised-button class="btn-add" (click)="newEmployee()">
        Novo
      </button>
    </div>
  }
</div>

<div>
  <div class="mt-4">
    <!--    @if (checkPermission('pesquisar-paginado')) {-->
    <!--      <form-search [search]="inputSearch" (responseSearch)="search($event)" />-->
    <!--    }-->
    <div>
      @if (!loading) {
        <div>
          <table-list-simple
            [dataSource]="itemsList"
            [columns]="columns"
            (selectItem)="editItem($event)"
            (deleteItem)="deleteItem($event)"
          />
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
